"use strict";

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _objectSpread = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _nullishCoalesce(lhs, rhsFn) {
  if (lhs != null) {
    return lhs;
  } else {
    return rhsFn();
  }
}

function _optionalChain(ops) {
  var lastAccessLHS = undefined;
  var value = ops[0];
  var i = 1;

  while (i < ops.length) {
    var op = ops[i];
    var fn = ops[i + 1];
    i += 2;

    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }

    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn(function () {
        var _value;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (_value = value).call.apply(_value, [lastAccessLHS].concat(args));
      });
      lastAccessLHS = undefined;
    }
  }

  return value;
}

var u = [{
  name: "Company",
  subLinks: [{
    href: "https://discover.proxibid.com/about-us",
    name: "About Us"
  }, {
    href: "https://discover.proxibid.com/careers-and-culture",
    name: "Careers"
  }, {
    href: "https://discover.proxibid.com/blog",
    name: "Blog"
  }, {
    href: "https://discover.proxibid.com/leadership",
    name: "Leadership"
  }, {
    href: "https://discover.proxibid.com/news",
    name: "Newsroom"
  }, {
    href: "https://discover.proxibid.com",
    name: "Marketplace Trust"
  }, {
    href: "https://www.auctiontechnologygroup.com",
    name: "Auction\nTechnology Group"
  }]
}, {
  name: "Customer Support",
  subLinks: [{
    href: "https://discover.proxibid.com/contact-us",
    name: "Contact Us"
  }, {
    href: "https://support.proxibid.com",
    name: "Help"
  }]
}, {
  name: "Privacy & Use",
  subLinks: [{
    href: "/asp/privacypolicy.asp",
    name: "Privacy Policy"
  }, {
    href: "/asp/unifieduseragreement.asp",
    name: "User Agreement"
  }, {
    href: "accessibility",
    name: "Accessibility"
  }]
}, {
  name: "Resources",
  subLinks: [{
    href: "/asp/loginauctioneer.asp",
    name: "Seller Login"
  }, {
    href: "/asp/createbidder.asp",
    name: "Buyer Sign Up"
  }, {
    href: "/asp/createseller.asp",
    name: "Apply to Sell"
  }, {
    href: "https://discover.proxibid.com/buying",
    name: "Buying"
  }, {
    href: "https://discover.proxibid.com/selling",
    name: "Selling"
  }]
}];

var _facebookIcon = require('@liveauctioneers/hammer-ui-core/icons/facebookIcon');

var _instagramIcon = require('@liveauctioneers/hammer-ui-core/icons/instagramIcon');

var _linkedinIcon = require('@liveauctioneers/hammer-ui-core/icons/linkedinIcon');

var _twitterIcon = require('@liveauctioneers/hammer-ui-core/icons/twitterIcon');

var _youtubeIcon = require('@liveauctioneers/hammer-ui-core/icons/youtubeIcon');

var S = [{
  ariaLabel: "Go to our facebook",
  href: "https://facebook.com/Proxibid",
  iconComponent: _facebookIcon.FacebookIconMedium
}, {
  ariaLabel: "Go to our twitter",
  href: "https://twitter.com/Proxibid",
  iconComponent: _twitterIcon.TwitterIconMedium
}, {
  ariaLabel: "Go to our instagram",
  href: "https://www.instagram.com/Proxibid",
  iconComponent: _instagramIcon.InstagramIconMedium
}, {
  ariaLabel: "Go to our linkedin",
  href: "https://www.linkedin.com/company/proxibid",
  iconComponent: _linkedinIcon.LinkedinIconMedium
}, {
  ariaLabel: "Go to our youtube",
  href: "https://www.youtube.com/user/Proxibid",
  iconComponent: _youtubeIcon.YoutubeIconMedium
}];

var _jotai = require('jotai');

var L = function L() {
  var e = document.querySelectorAll('[data-acsb-custom-trigger="true"]');

  if (e.length > 0) {
    var t = new MutationObserver(function (o) {
      var _iterator = _createForOfIteratorHelper(o),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var r = _step.value;
          r.attributeName === "role" && (setTimeout(function () {
            var _iterator2 = _createForOfIteratorHelper(e),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var i = _step2.value;
                i.click();
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }, 10), t.disconnect());
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });

    var _iterator3 = _createForOfIteratorHelper(e),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var o = _step3.value;
        t.observe(o, {
          attributes: !0
        });
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  window.acsbJS.init({
    disableBgProcess: !1,
    footerHtml: "",
    hideMobile: !1,
    hideTrigger: !0,
    language: "en",
    leadColor: "#146FF8",
    mobile: {
      triggerOffsetX: 0,
      triggerOffsetY: 0,
      triggerPositionX: "left",
      triggerPositionY: "center",
      triggerRadius: "0",
      triggerSize: "small"
    },
    position: "right",
    statementLink: "",
    triggerColor: "",
    triggerIcon: "people",
    triggerOffsetX: 20,
    triggerOffsetY: 20,
    triggerPositionX: "left",
    triggerPositionY: "bottom",
    triggerRadius: "50%",
    triggerSize: "medium"
  });
};

var _react = require('react');

var p = function p() {
  var e = _react.useRef.call(void 0, {}),
      t = _react.useCallback.call(void 0, function (r, i) {
    if (typeof document > "u" || r in e) return;
    var s = document.head,
        n = document.createElement("script");
    Object.assign(n, i), n.id = "".concat(r), s.appendChild(n), e.current[r] = n;
  }, []),
      o = _react.useCallback.call(void 0, function (r) {
    if (typeof document > "u") return;
    var i = document.getElementById("".concat(r, "-useAppendScript"));

    if (i === null) {
      process.env.NODE_ENV !== "production" && console.error("Script ".concat(r, " could not be found, did not remove."));
      return;
    }

    _optionalChain([i, 'access', function (_2) {
      return _2.parentNode;
    }, 'optionalAccess', function (_3) {
      return _3.removeChild;
    }, 'call', function (_4) {
      return _4(i);
    }]), delete e.current[r];
  }, []);

  return {
    register: t,
    unregister: o
  };
};

var f = _jotai.atom.call(void 0, !1),
    C = function C() {
  var _p = p(),
      e = _p.register,
      t = _jotai.useAtomValue.call(void 0, f),
      o = _react.useRef.call(void 0, !1);

  return _react.useEffect.call(void 0, function () {
    o.current || !t || (window.acsbJS ? o.current = !0 : window.acsbJS || (e("accessibilityWidget", {
      async: !0,
      onload: L,
      src: "https://acsbapp.com/apps/app/dist/js/app.js"
    }), o.current = !0));
  }, [t, e]), null;
};

var _text = require('@liveauctioneers/hammer-ui-core/text');

var _button = require('@liveauctioneers/hammer-ui-core/button');

var _checkmarkIcon = require('@liveauctioneers/hammer-ui-core/icons/checkmarkIcon');

var _reacthookform = require('react-hook-form');

var _textInput = require('@liveauctioneers/hammer-ui-core/textInput');

var _styledcomponents = require('styled-components');

var _styledcomponents2 = _interopRequireDefault(_styledcomponents);

var _jsxruntime = require('react/jsx-runtime');

var E = function E(_ref) {
  var e = _ref.onSubscribeClick;

  var _react$useState$call = _react.useState.call(void 0, !1),
      _react$useState$call2 = _slicedToArray(_react$useState$call, 2),
      t = _react$useState$call2[0],
      o = _react$useState$call2[1],
      _react$useState$call3 = _react.useState.call(void 0, !1),
      _react$useState$call4 = _slicedToArray(_react$useState$call3, 2),
      r = _react$useState$call4[0],
      i = _react$useState$call4[1],
      _reacthookform$useFor = _reacthookform.useForm.call(void 0),
      _reacthookform$useFor2 = _reacthookform$useFor.formState,
      s = _reacthookform$useFor2.errors,
      n = _reacthookform$useFor2.isDirty,
      O = _reacthookform$useFor.handleSubmit,
      $ = _reacthookform$useFor.register,
      N = _reacthookform$useFor.reset,
      D = _reacthookform$useFor.watch,
      x = D("email"),
      R = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(U) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              o(!0);
              _context.next = 3;
              return e(U.email);

            case 3:
              o(!1);
              N();
              i(!0);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function R(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return _react.useEffect.call(void 0, function () {
    x && r && i(!1);
  }, [x, r]), _jsxruntime.jsxs.call(void 0, ae, {
    children: [_jsxruntime.jsx.call(void 0, _text.H5, {
      $marginBottom: "8px",
      as: "div",
      color: "inverse",
      children: "Connect With Us"
    }), _jsxruntime.jsx.call(void 0, _text.BodyPrimary, {
      color: "inverse",
      children: "Be the first to know with our newsletters"
    }), _jsxruntime.jsxs.call(void 0, ce, {
      onSubmit: O(R),
      children: [_jsxruntime.jsxs.call(void 0, me, {
        children: [_jsxruntime.jsx.call(void 0, _textInput.TextInput, _objectSpread({
          "aria-label": "Email Address",
          autoFocus: n,
          "data-testid": "emailSubscribe",
          defaultValue: "",
          disabled: t,
          errorText: _nullishCoalesce(_optionalChain([s, 'access', function (_5) {
            return _5.email;
          }, 'optionalAccess', function (_6) {
            return _6.message;
          }]), function () {
            return "";
          }),
          errorTextId: "errorMessage",
          hasError: !!s.email,
          id: "emailSubscribe",
          placeholder: r ? "Subscribed, thank you!" : "Email Address",
          small: !0,
          type: "email"
        }, $("email", {
          pattern: {
            message: "Please enter a valid email address",
            value: /\S+@\S+\.\S+/
          },
          required: !0
        }))), r && _jsxruntime.jsx.call(void 0, pe, {
          color: "success"
        })]
      }), _jsxruntime.jsx.call(void 0, _button.Button, {
        loading: t,
        small: !0,
        type: "submit",
        children: "Subscribe"
      })]
    })]
  });
},
    ae = _styledcomponents2.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    margin-bottom: 24px;\n"]))),
    ce = _styledcomponents2.default.form(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-top: 8px;\n"]))),
    me = _styledcomponents2.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-right: 8px;\n    width: 100%;\n    position: relative;\n"]))),
    pe = _styledcomponents2.default.call(void 0, _checkmarkIcon.CheckmarkIconSmall)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    position: absolute;\n    right: 8px;\n    top: 8px;\n"])));

var _link = require('@liveauctioneers/hammer-ui-core/link');

var _providers = require('@liveauctioneers/hammer-ui-core/providers');

var G = function G(_ref3) {
  var e = _ref3.footerLink;

  var t = _providers.usePreventDefaultLinkOnClick.call(void 0);

  return _jsxruntime.jsxs.call(void 0, fe, {
    children: [_jsxruntime.jsx.call(void 0, _text.H5, {
      $marginBottom: "4px",
      as: "h3",
      color: "inverse",
      children: e.name
    }), e.subLinks.map(function (o) {
      return _jsxruntime.jsx.call(void 0, be, {
        "data-acsb-custom-trigger": o.href === "accessibility" ? "true" : "false",
        href: o.href,
        onClick: t(o.href),
        size: "sm",
        children: o.name
      }, o.href);
    })]
  });
},
    fe = _styledcomponents2.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: column;\n"]))),
    be = _styledcomponents2.default.call(void 0, _link.SubtleInverseLink)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    margin: 12px 0 0 0;\n    white-space: pre-wrap;\n"])));

var _chevronDownIcon = require('@liveauctioneers/hammer-ui-core/icons/chevronDownIcon');

var _chevronUpIcon = require('@liveauctioneers/hammer-ui-core/icons/chevronUpIcon');

var W = function W(_ref4) {
  var e = _ref4.activeGroup,
      t = _ref4.footerLink,
      o = _ref4.setActiveGroup;

  var r = _providers.usePreventDefaultLinkOnClick.call(void 0),
      i = function i() {
    e !== t.name ? o(t.name) : o("");
  },
      s = e === t.name;

  return _jsxruntime.jsxs.call(void 0, Le, {
    children: [_jsxruntime.jsxs.call(void 0, ve, {
      $isActiveGroup: s,
      onClick: i,
      children: [_jsxruntime.jsx.call(void 0, _text.H5, {
        as: "span",
        color: "inverse",
        children: t.name
      }), s ? _jsxruntime.jsx.call(void 0, _chevronUpIcon.ChevronUpIconSmall, {
        color: "inverse"
      }) : _jsxruntime.jsx.call(void 0, _chevronDownIcon.ChevronDownIconSmall, {
        color: "inverse"
      })]
    }), _jsxruntime.jsx.call(void 0, Ce, {
      $hide: !s,
      children: t.subLinks.map(function (n) {
        return _jsxruntime.jsx.call(void 0, _link.SubtleInverseLink, {
          $margin: "12px 0 12px 24px",
          "data-acsb-custom-trigger": n.href === "accessibility" ? "true" : "false",
          href: n.href,
          onClick: r(n.href),
          size: "sm",
          children: n.name
        }, n.href);
      })
    })]
  });
},
    Le = _styledcomponents2.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: column;\n    border-bottom: 1px solid ", ";\n"])), function (_ref5) {
  var e = _ref5.theme;
  return e.color.border.divider.inverse;
}),
    ve = _styledcomponents2.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    display: flex;\n    padding: 12px 0;\n    justify-content: space-between;\n"]))),
    Ce = _styledcomponents2.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    margin-bottom: 12px;\n    display: flex;\n    flex-flow: column;\n\n    ", "\n"])), function (_ref6) {
  var e = _ref6.$hide;
  return e && _styledcomponents.css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n            height: 0;\n            width: 0;\n            overflow: hidden;\n            margin-bottom: 0;\n        "])));
});

var T = function T() {
  var _react$useState$call5 = _react.useState.call(void 0, ""),
      _react$useState$call6 = _slicedToArray(_react$useState$call5, 2),
      e = _react$useState$call6[0],
      t = _react$useState$call6[1];

  return _jsxruntime.jsxs.call(void 0, _jsxruntime.Fragment, {
    children: [_jsxruntime.jsx.call(void 0, Pe, {
      children: u.map(function (o, r) {
        return _jsxruntime.jsx.call(void 0, W, {
          activeGroup: e,
          footerLink: o,
          setActiveGroup: t
        }, r);
      })
    }), _jsxruntime.jsx.call(void 0, Ee, {
      children: u.map(function (o, r) {
        return _jsxruntime.jsx.call(void 0, G, {
          footerLink: o
        }, r);
      })
    })]
  });
},
    Ee = _styledcomponents2.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    grid-area: links;\n    display: grid;\n    width: 100%;\n    justify-content: space-between;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n\n    @media (max-width: ", "px) {\n        display: none;\n    }\n"])), 1103),
    Pe = _styledcomponents2.default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    grid-area: links;\n    display: flex;\n    flex-flow: column;\n    width: 100%;\n    margin-bottom: 48px;\n\n    @media (min-width: ", "px) {\n        display: none;\n    }\n"])), 1103 + 1);

var z = function z() {
  var e = _providers.usePreventDefaultLinkOnClick.call(void 0);

  return _jsxruntime.jsx.call(void 0, Be, {
    children: S.map(function (t) {
      return _jsxruntime.jsx.call(void 0, "a", {
        "aria-label": t.ariaLabel,
        href: t.href,
        onClick: e(t.href),
        children: _jsxruntime.jsx.call(void 0, t.iconComponent, {
          color: "inverse",
          cursor: "pointer"
        })
      }, t.href);
    })
  });
},
    Be = _styledcomponents2.default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n"])));

var M = function M() {
  return function () {
    typeof window.zE == "function" && (window.zESettings = {
      webWidget: {
        chat: {
          departments: {
            enabled: []
          }
        },
        zIndex: 1200
      }
    }, window.zE("webWidget:on", "chat:departmentStatus", function (e) {
      e.name === "Proxibid Customer Experience" && e.status === "online" ? window.zE("webWidget", "updateSettings", {
        webWidget: {
          chat: {
            departments: {
              enabled: [""],
              select: "Proxibid Customer Experience"
            },
            suppress: !1
          },
          zIndex: 1200
        }
      }) : e.name === "Proxibid Customer Experience" && e.status !== "online" && window.zE("webWidget", "updateSettings", {
        webWidget: {
          chat: {
            suppress: !0
          },
          zIndex: 1200
        }
      });
    })), window.zE("webWidget", "show");
  };
};

var H = function H() {
  var _p2 = p(),
      e = _p2.register,
      t = _p2.unregister,
      o = _react.useRef.call(void 0, !1);

  return _react.useEffect.call(void 0, function () {
    if (document.body.clientWidth < 1103) {
      window.zE && window.zE("webWidget", "hide");
      return;
    }

    if (o.current) {
      window.zE && window.zE("webWidget", "show");
      return;
    }

    window.zE ? o.current = !0 : window.zE || (e("ze-snippet", {
      async: !0,
      id: "ze-snippet",
      onload: M(),
      src: "https://static.zdassets.com/ekr/snippet.js?key=567717b4-efa9-4d39-b639-5caacb3e838a"
    }), o.current = !0);
  }, [e, t]), null;
};

var Qo = function Qo(_ref7) {
  var e = _ref7.className,
      t = _ref7.onSubscribeClick;

  var o = _providers.useOnLinkClick.call(void 0),
      r = _jotai.useSetAtom.call(void 0, f);

  return _jsxruntime.jsx.call(void 0, _providers.LinkProvider, {
    onLinkClick: function onLinkClick(s) {
      s !== "accessibility" ? o(s) : r(!0);
    },
    children: _jsxruntime.jsxs.call(void 0, $e, {
      children: [_jsxruntime.jsxs.call(void 0, Ne, {
        className: e,
        children: [_jsxruntime.jsx.call(void 0, T, {}), _jsxruntime.jsxs.call(void 0, De, {
          children: [_jsxruntime.jsx.call(void 0, E, {
            onSubscribeClick: t
          }), _jsxruntime.jsx.call(void 0, z, {})]
        })]
      }), _jsxruntime.jsx.call(void 0, C, {}), _jsxruntime.jsx.call(void 0, H, {})]
    })
  });
},
    $e = _styledcomponents2.default.footer(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    background: ", ";\n    align-items: center;\n\n    @media print {\n        display: none;\n    }\n"])), function (_ref8) {
  var e = _ref8.theme;
  return e.color.background.tertiary;
}),
    Ne = _styledcomponents2.default.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    max-width: ", ";\n    width: 100%;\n    padding: 48px 24px 64px 24px;\n    display: grid;\n    grid-template-areas: 'links social';\n    grid-template-columns: 1fr 342px;\n    grid-template-rows: 1fr;\n\n    @media (max-width: ", "px) {\n        padding: 0px 16px 64px 16px;\n        grid-template-areas: 'links' 'social';\n        grid-template-columns: 1fr;\n        grid-template-rows: 1fr min-content;\n    }\n\n    column-gap: 75px;\n"])), function (_ref9) {
  var e = _ref9.theme;
  return e.breakpoints.xlMin;
}, 1103),
    De = _styledcomponents2.default.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    grid-area: social;\n    max-width: 342px;\n"])));

exports.Footer = Qo;
exports.footerLinks = u;
exports.socialLinks = S;